import { render, staticRenderFns } from "./BaseStaffQrCode.vue?vue&type=template&id=1b6901b4&scoped=true"
import script from "./BaseStaffQrCode.vue?vue&type=script&lang=js"
export * from "./BaseStaffQrCode.vue?vue&type=script&lang=js"
import style0 from "./BaseStaffQrCode.vue?vue&type=style&index=0&id=1b6901b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6901b4",
  null
  
)

export default component.exports